import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ChangeRequestsList from '../../../manager/MyTeam/MyTeamChangeRequests/ChangeRequestsList';
import Loading from '../../../manager/MyTeam/MyTeamChangeRequests/ChangeRequestsList/Loading';
import ServerError from '../../../../../components/ServerError';
import { useMyEmployeeDataChangeRequestsQuery } from '../../../__generated__/graphql';

export const MyEmployeeDataChangeRequests: React.FC = () => {
  const { data, loading, error } = useMyEmployeeDataChangeRequestsQuery();

  if (loading) {
    return <Loading />;
  }

  if (error || data === undefined) {
    return <ServerError />;
  }
  const changeRequests = data.me.employeeDataChangeRequests;
  return (
    <>
      <Row>
        <Col>
          <ChangeRequestsList mode="employee" changeRequests={changeRequests} />
        </Col>
      </Row>
    </>
  );
};
